import { Injectable, Type } from '@angular/core';

export interface ComponentMeta {
  component: Type<any>;
  requiresRoute?: boolean;
  routePath?: string;
  buildQueryParams?: (params: any) => any;
}

@Injectable({
  providedIn: 'root',
})
export class ComponentRegistryService {
  private componentMap: { [key: string]: ComponentMeta } = {};

  registerComponent(selector: string, component: Type<any>, requiresRoute: boolean  = false, routePath?: string, buildQueryParams?: (params: any) => any) {
    this.componentMap[selector] = { component, requiresRoute, routePath, buildQueryParams };
  }

  getComponent(selector: string): Type<any> | undefined {
    return this.componentMap[selector]?.component;
  }

  getMeta(selector: string): ComponentMeta | undefined {
    return this.componentMap[selector];
  }
}
